export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6209.48a7cd3f.jpg";